const tabsespdcol = document.querySelectorAll('.tabs__btnpdcol');
const tabsContentcol = document.querySelectorAll('.tabs__bodypdcol');
if (tabsContentcol.length > 0 ) {
    function hideTabContent() {
        tabsContentcol.forEach(item => {
            item.classList.remove('active');
        });

        tabsespdcol.forEach(item => {
            item.classList.remove('active');
        });
    }
    function showTabContent(i = 0) {
        tabsContentcol[i].classList.add('active');
        tabsespdcol[i].classList.add('active');
    }

    hideTabContent();
    showTabContent();

    tabsespdcol.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            hideTabContent();
            showTabContent(index);
        });
    });
}

var swiper = new Swiper(".new-featured-slider", {
  loop: true,
  centeredSlides: false,
  navigation: {
    nextEl: ".new-arrows-next",
    prevEl: ".new-arrows-perv",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
    draggable: true,
  },
  breakpoints: {
    1300: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    800: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
    671: {
       slidesPerView: 2.6,
      spaceBetween: 50,
    },
    670: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    0: {
      slidesPerView: 2,
      spaceBetween: 20,
    }
  }
});